import { VideoModalComponent } from "src/app/components/common/video-modal/video-modal.component";
import { Component } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-testimonials",
  templateUrl: "./testimonials.component.html",
  styleUrls: ["./testimonials.component.scss"],
})
export class TestimonialsComponent {
  testimonials = [
    {
      name1: "BBPS Student",
      name2: "  (BBPS School)",
      image:
        environment.assUrl + "assets/images/testimonials/student_of_bbps.jpg",
      videoLink:
        " https://d2abnqj5vuy2s4.cloudfront.net/Student Testimonials/bbps_student_feedback.mp4",
      details:
        "Today a workshop was held in our school in which Vishal vadhaniji take flute and Firoz sir take Tabla. It was really great and glorious morning. It was a really great experience to listen to them and get some professional takes from and It was like a dream coming true ......",
      color: "#FFF7FE",
    },
    {
      name1: "Harshta Mathur",
      name2: "  (Kendriya Vidyalaya Guna)",
      image:
        environment.assUrl + "assets/images/testimonials/Harshta_Mathur_01.png",
      videoLink:
        "https://d2abnqj5vuy2s4.cloudfront.net/Student Testimonials/harshita_mathur_kv_guna.mp4",
      details:
        "I'm Harshita Mathur a student of class 12th A from KV Guna I'm so grateful to Virsa and such that gave us a wonderful opportunity in order to have a Dr. Premvada mam today with us here she presented herself in such a beautiful manner we are so blessed to have her ....",
      color: "#F7FEFF",
    },
    {
      name1: "Nandani Kumari",
      name2: "  (ITBP Shivpuri)",
      image:
        environment.assUrl + "assets/images/testimonials/Nandani_Kumari_01.png",
      videoLink:
        "https://d2abnqj5vuy2s4.cloudfront.net/Student Testimonials/nandini_kumari_kv_ara.mp4",
      details:
        "First of all, I want to say thank you to Virsa because you have done this workshop in our school, I am very happy with this and I have learned a lot through Virsa, we also learned about cultural dance song music all, I hope Virsa always taught us and come in our school. we ...",
      color: "#FFFFF7",
    },
    {
      name1: "Shruti Pandey",
      name2: "  (Kendriya Vidyalaya Ara)",
      image:
        environment.assUrl + "assets/images/testimonials/Shruti_Pandey_01.png",
      videoLink:
        "https://d2abnqj5vuy2s4.cloudfront.net/Student Testimonials/shruti_panday_kv_itbp_shivpuri.mp4",
      details:
        "Good morning, I am Shruti Pandey, a student of class 11, I study in Kendriya Vidyalaya ITBP Shivpuri, Today's program was organized by Virsa in our school in which Dr. Premvada Maam made us understand all the things that we have never seen before. Bharatnatyam is a .....",
      color: "#FFF7F7",
    },
  ];

  constructor(private dialog: MatDialog) {}

  openDialog(name: string, url: string) {
    this.dialog.open(VideoModalComponent, {
      enterAnimationDuration: "400ms",
      data: {
        title: name,
        video: url,
        discription: "",
        vimeo: true,
      },
    });
  }
}
